import React, { useMemo } from 'react'

import { useTestKitProducts } from '../../../../lib/products/hooks/useTestKitProducts'
import { RestrictedItemsList, RestrictedItemsListProps } from './RestrictedItemsList'
import {
  ShippingRestrictionsModal,
  ShippingRestrictionsModalProps,
} from './ShippingRestrictionsModal'
import { ModalMessage, TestKitItemMessage } from './styled'

export type RegionShippingRestrictionsModalProps = RestrictedItemsListProps &
  ShippingRestrictionsModalProps & {
    className?: string
  }

export const RegionShippingRestrictionsModal: React.FC<RegionShippingRestrictionsModalProps> = ({
  className,
  handleClose,
  handleContinue,
  handleRemoveItems,
  loading,
  open,
  removeItemsError,
  restrictedItems = [],
  region,
}) => {
  const { isTestKitSku } = useTestKitProducts()
  const showTestKitItemMessage = useMemo(
    () =>
      restrictedItems.some((restrictedItem) => isTestKitSku(restrictedItem.sku) && region === 'NY'),
    [isTestKitSku, restrictedItems, region],
  )

  return (
    <ShippingRestrictionsModal
      className={className}
      handleClose={handleClose}
      handleContinue={handleContinue}
      handleRemoveItems={handleRemoveItems}
      loading={loading}
      open={open}
      removeItemsError={removeItemsError}
    >
      <ModalMessage variant="body2" gutterBottom>
        The following item(s) in your cart cannot be shipped to the state you&apos;ve selected:
      </ModalMessage>
      <RestrictedItemsList restrictedItems={restrictedItems}>
        {showTestKitItemMessage && (
          <TestKitItemMessage variant="body2">
            Due to legal requirements, DFH does not deliver biological sample collection kits to, or
            accept delivery of biological samples mailed from, New York state addresses.
          </TestKitItemMessage>
        )}
      </RestrictedItemsList>
    </ShippingRestrictionsModal>
  )
}
